import { render, staticRenderFns } from "./EditBatch.vue?vue&type=template&id=3d4e5d70&scoped=true&"
import script from "./EditBatch.vue?vue&type=script&lang=js&"
export * from "./EditBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4e5d70",
  null
  
)

export default component.exports